import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42021d96&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/pages/Documentacao/Views/stylesManual.scss?vue&type=style&index=0&id=42021d96&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42021d96",
  null
  
)

export default component.exports